import React from "react"
import { useRouter } from "next/router"
import styled from "styled-components"
import ListCard from "./ListCardVertical"
import { themeGet } from "@styled-system/theme-get"
import { useTranslation } from "next-i18next"

interface HotArticleProps {
  data: any[]
  articleName: string
  tagData: any[]
}

export default function HotArticle({
  data,
  articleName,
  tagData
}: HotArticleProps) {
  const { locale } = useRouter()
  const { t } = useTranslation("common")
  // 把tag裡面的hot過濾掉
  const NoHotTags = tagData?.filter(tag => (tag === "hot" ? false : true))

  const Articles = data.filter(article =>
    article.attributes?.tags?.data.some(({ attributes }: any) =>
      NoHotTags.map(tag => {
        if (attributes.name === tag) {
          return true
        } else {
          return false
        }
      })
    )
  )

  const ArticlesWithoutThis = Articles.filter(article =>
    article.attributes.title === articleName ? false : true
  )

  const recommendArticles = ArticlesWithoutThis.slice(1, 4)

  return (
    <Wrapper>
      <TitleWrapper>
        <h3>{t("recommend-articles")}</h3>
      </TitleWrapper>
      <CardsList>
        {recommendArticles?.map(e => (
          <ListCard
            title={e.attributes.title}
            link={`${locale === "en" ? "" : `/${locale}`}/blog/${
              e.attributes["blog_identifier"].data.attributes.Identifier
            }`}
            img={
              e?.attributes?.cover_image?.data?.attributes?.formats?.medium
                ?.url || e?.attributes?.cover_image?.data?.attributes?.url // GIF
            }
            alt="123"
            key={e.id}
          />
        ))}
      </CardsList>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  gap: 40px;
  position: relative;
`

const TitleWrapper = styled.div`
  height: 30px;
  h3 {
    font-size: 24px;
    margin: 0;
    font-weight: 900;
    // margin-left: 16px;
  }
  // &:before {
  //   content: "";
  //   width: 100%;
  //   height: 30px;
  //   border-left: 4px solid ${themeGet("colors.primary")};
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  // }
`

const CardsList = styled.div`
  display: flex;
  gap: 24px;
  display: flex;
  flex-direction: row;
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin-top: 2em;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 40px;
  }
`
